export function reportClinicianSearchError(err) {
  // eslint-disable-next-line no-console
  console.error(err);
  if (typeof window !== 'undefined') {
    window._bugsnagClient?.notify(err);
  }
}
